import { computeHeadingLevel } from "@testing-library/dom";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import "./GymInfo.css";
import equipmentImg from "./../../images/press.png";
import championImg from "./../../images/badge.png";
import areaImg from "./../../images/area-chart.png";
import parkingImg from "./../../images/car-parking.png";
import swimmingPoolImg from "./../../images/swimming-pool.png";
import nutritionImg from "./../../images/sportsNutrition.png";

const GymInfoContent = [
  {
    name: `Modern\nequipment`,
    img: equipmentImg,
  },
  {
    name: `Coaches\nchampions`,
    img: championImg,
  },
  {
    name: `The area\nof 9000 m2`,
    img: areaImg,
  },
  {
    name: `Parking for\n160 spots`,
    img: parkingImg,
  },
  {
    name: `Swimming pools\navailable`,
    img: swimmingPoolImg,
  },
  {
    name: `Large bar with\nsports nutrition`,
    img: nutritionImg,
  },
];

const GymInfo = () => {
  return (
    <Container className="text-center my-5">
      <h2 style={{ color: "#23182c", lineHeight: "1.3" }}>
        We can give you <br />
        <span className="brand_text">much more than other</span>
      </h2>
      <Row>
        {GymInfoContent.map((data, i) => {
          console.log(data.name);
          return (
            <Col xs={6} md={4} lg={2} className="p-3">
              <div className="m-4">
                <img className="mb-4" src={data.img} alt="equipment" style={{maxWidth:'75px'}} />
                <h4>{data.name}</h4>
              </div>
            </Col>
          );
        })}
      </Row>
    </Container>
  );
};

export default GymInfo;
